import {
  PERK_AMOUNT,
  PERK_DURATION,
  PERK_OPTIONS,
  PERK_TOOLS,
} from "@/constants/perk";

export type PerkItem = {
  type: string;
  option: string;
  amount: string;
  duration: string;
  tools: string;
};

const getPerkItem = (perkCategoryId: number, perkTypeId: number): PerkItem => {
  let perkType: string = "";
  let perkOption: string = "";
  let perkDuration: string = "";
  let perkAmount: string = "";
  let perkTools: string = "";

  if (perkCategoryId >= 18 && perkCategoryId <= 23) {
    perkType = "success";
    perkOption = PERK_OPTIONS["success"].map((option) => option.id)[
      perkCategoryId - 18
    ];

    const perkAmountIds = PERK_AMOUNT["success"].map((duration) => duration.id);
    const perkDurationIds = PERK_DURATION.map((duration) => duration.id);
    perkAmount = perkAmountIds[Math.floor(perkTypeId / perkDurationIds.length)];
    perkDuration = PERK_DURATION[perkTypeId % perkDurationIds.length].id;
  } else if (perkCategoryId >= 24 && perkCategoryId <= 32) {
    perkType = "cooldown";
    perkOption = PERK_OPTIONS["cooldown"].map((option) => option.id)[
      perkCategoryId - 24
    ];
    const perkAmountIds = PERK_AMOUNT["cooldown"].map(
      (duration) => duration.id
    );
    const perkDurationIds = PERK_DURATION.map((duration) => duration.id);
    perkAmount = perkAmountIds[Math.floor(perkTypeId / perkDurationIds.length)];
    perkDuration = PERK_DURATION[perkTypeId % perkDurationIds.length].id;
  } else if (perkCategoryId >= 33 && perkCategoryId <= 40) {
    perkType = "booster";
    perkOption = PERK_OPTIONS["booster"].map((option) => option.id)[
      perkCategoryId - 33
    ];
    const perkAmountIds = PERK_AMOUNT["booster"].map((duration) => duration.id);
    const perkDurationIds = PERK_DURATION.map((duration) => duration.id);
    perkAmount = perkAmountIds[Math.floor(perkTypeId / perkDurationIds.length)];
    perkDuration = PERK_DURATION[perkTypeId % perkDurationIds.length].id;
  } else if (perkCategoryId >= 41 && perkCategoryId <= 47) {
    perkType = "tools";

    perkTools = PERK_TOOLS.map((tool) => tool.id)[perkCategoryId - 41];

    const perkDurationIds = PERK_DURATION.map((duration) => duration.id);
    perkDuration = PERK_DURATION[perkTypeId % perkDurationIds.length].id;
  }

  return {
    type: perkType,
    option: perkOption,
    amount: perkAmount,
    duration: perkDuration,
    tools: perkTools,
  };
};

export default getPerkItem;
